module.exports = __webpack_public_path__ + "img/codepen-circle.7c8ffb3c.svg";